export default __webpack_public_path__ + "static/media/v2.86d45d15.png";